module.exports = __webpack_public_path__ + "static/media/funds_retire_bg.7c4694e9.jpg";